import {
  House, Phone, User, Menu, Smartphone, Shield, Users, Globe, Clock, Zap,
  CircleAlert, CheckCircle, XCircle, PhoneOff, MapPin, Calendar,
  Settings, Edit3, Mail, Award, Heart, ChevronDown, ArrowLeft, ArrowRight,
  Eye, EyeOff, Bell, Sunrise, Sunset, AlertTriangle
} from 'lucide-react'

const iconMap = {
  House, Phone, User, Menu, Smartphone, Shield, Users, Globe, Clock, Zap,
  CircleAlert, CheckCircle, XCircle, PhoneOff, MapPin, Calendar,
  Settings, Edit3, Mail, Award, Heart, ChevronDown, ArrowLeft, ArrowRight,
  Eye, EyeOff, Bell, Sunrise, Sunset, AlertTriangle
}

export const useIcon = (iconName) => iconMap[iconName] || User

export const getIcon = (iconName, size = 24) => {
  const IconComponent = iconMap[iconName] || User
  return <IconComponent size={size} />
}